import useDemoHelper from "./useDemoHelper";
import step101 from "../../../../../assets/demo/emergency/10.1.mp3";
import step102 from "../../../../../assets/demo/emergency/10.2.mp3";
import step103 from "../../../../../assets/demo/emergency/10.3.mp3";
import {useNavigate} from "react-router";
import route from "../../../../../enum/route";
import isNull from "../../../../../mixin/isNull";

window.sound = new Audio();

export default function () {
    const navigate = useNavigate();
    const demoHelper = useDemoHelper();

    const flashButtonHelp = () => {
        const element = document.querySelector('[data-test="skeleton-body"]');
        element.scrollTop = element.scrollHeight;

        demoHelper.flash('[data-test="open-signature-tutorial"]', 3);
    }

    const clickButtonHelp = () => {
        demoHelper.click('[data-test="open-signature-tutorial"]');
    }

    const clickToSkipSignature = async visual => {
        if (!visual) {
            demoHelper.flash('[data-test="button-skip-signature"]', 3);

            await demoHelper.sleep(3000);

            if (!isNull(document.getElementsByClassName("MuiFab-warning")[0])) {
                document.getElementsByClassName("MuiFab-warning")[0]?.click();
            }

            return;
        }

        demoHelper.click('[data-test="button-skip-signature"]');
    }

    const flashClientInvoiceDetails = () => {
        demoHelper.flash('[data-test="client-invoice-details"]', 5);
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 17 seconds
            window.sound.src = step101;
            window.sound.play();

            await demoHelper.sleep(5000);

            flashButtonHelp();

            await demoHelper.sleep(3000);

            clickButtonHelp();

            await demoHelper.sleep(5000);

            clickToSkipSignature(visual);

            await demoHelper.sleep(5000);

            // 22 seconds
            window.sound.src = step102;
            window.sound.play();

            await demoHelper.sleep(10000);

            flashClientInvoiceDetails();

            await demoHelper.sleep(12000);

            // 12 seconds
            window.sound.src = step103;
            window.sound.play();

            await demoHelper.sleep(13000);

            navigate(route.ROOT);
        }
    }
}